import { useEffect } from "react";
import "./ModalItens.css";

export default function ModalItens({
  aberto,
  titulo,
  tipo,
  itens,
  moeda,
  onClose,
}) {

  useEffect(() => {

    function fecharESC(e) {

      if (e.key === "Escape") {
        onClose();
      }

    }

    if (aberto) {
      window.addEventListener("keydown", fecharESC);
    }

    return () =>
      window.removeEventListener(
        "keydown",
        fecharESC
      );

  }, [aberto, onClose]);

  if (!aberto) {
    return null;
  }

  return (

    <div
      className="modalitens-overlay"
      onClick={onClose}
    >

      <div
        className="modalitens"
        onClick={(e) =>
          e.stopPropagation()
        }
      >

        <div className="modalitens-header">

          <h2>

            {titulo}

          </h2>

          <button
            className="modalitens-fechar"
            onClick={onClose}
          >

            ✕

          </button>

        </div>

        <div className="modalitens-body">

          <table className="modalitens-table">

            <thead>

              <tr>

                <th>Código</th>

                <th>Descrição</th>

                <th>Qtde</th>

                <th>Valor Unitário</th>

                <th>Total</th>

              </tr>

            </thead>

            <tbody>

              {itens.map((item, index) => {

                const unitario =
                  tipo === "pedido"
                    ? item.precounitario
                    : item.valorunitario;

                const total =
                  tipo === "pedido"
                    ? item.precototal
                    : item.valortotal;

                return (

                  <tr
                    key={
                      item.seq ??
                      item.coditem ??
                      index
                    }
                  >

                    <td>

                      {item.coditem}

                    </td>

                    <td>

                      {item.descricao}

                    </td>

                    <td>

                      {item.qtde}

                    </td>

                    <td>

                      {moeda(unitario)}

                    </td>

                    <td>

                      {moeda(total)}

                    </td>

                  </tr>

                );

              })}

            </tbody>

          </table>

        </div>

      </div>

    </div>

  );

}